import axios from "axios";
import { apiUrl } from "../../config/constants";

export const restaurantsFetched = (restaurants) => ({
  type: "RESTAURANTS_FETCHED",
  payload: restaurants,
});

export const restaurantFetchedById = (restaurants) => ({
  type: "RESTAURANT_FETCHED_BY_ID",
  payload: restaurants,
});

export function fetchRestaurants(city) {
  return async function thunk(dispatch, getState) {
    try {
      const response = await axios.get(`${apiUrl}/cities/${city}`);

      const restaurants = response.data;

      dispatch(restaurantsFetched(restaurants));
    } catch (e) {
      console.log(e);
    }
  };
}

export function fetchRestaurantById(id) {
  return async function thunk(dispatch, getState) {
    try {
      const response = await axios.get(`${apiUrl}/restaurants/${id}`);

      const restaurant = response.data;

      dispatch(restaurantFetchedById(restaurant));
    } catch (e) {
      console.log(e);
    }
  };
}

// NEW ACTIONS TO 1 Restaurant
